import { useEffect, useState } from "react";
import WebSocketConnection from "../utils/WebSocketConnection";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import EventItem from "./EventItem";
import EventItemHeader from "./EventItemHeader";
import List from "@mui/material/List";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import { 
	BALL_FITTING_SPECS, 
	applySpec, 
	CLUB_TYPES
} from "../constants/ballFitting";
import { convertMsToMph } from "../utils/conversions";

const SwingRecording = ({ onAnalyze, shaftName, headName }) => {
  const [trackmanEvent, setTrackmanEvent] = useState([]);
  const [avgCarry, setAvgCarry] = useState(0);
  const [averages, setAverages] = useState(null);

  const calculateAverages = () => {
    if (trackmanEvent.length === 0) return null;

    let totalSwings = 0;
    let totals = {
      BallSpeed: 0,
      LaunchAngle: 0,
      SpinRate: 0
    };

    trackmanEvent.forEach((event) => {
      if (event.data.BallSpeed && event.data.LaunchAngle && event.data.SpinRate) {
        totals.BallSpeed += event.data.BallSpeed;
        totals.LaunchAngle += event.data.LaunchAngle;
        totals.SpinRate += event.data.SpinRate;
        totalSwings++;
      }
    });

    if (totalSwings === 0) return null;

    const clubType = localStorage.getItem("clubType") || CLUB_TYPES.DRIVERS;
    const specs = BALL_FITTING_SPECS[clubType];
    
    const avgBallSpeed = totals.BallSpeed / totalSwings;
    const avgLaunchAngle = totals.LaunchAngle / totalSwings;
    const avgSpinRate = totals.SpinRate / totalSwings;

    return {
      ballSpeed: applySpec(convertMsToMph(avgBallSpeed), specs.ballSpeed),
      launch: applySpec(avgLaunchAngle, specs.launchAngle),
      spin: applySpec(avgSpinRate, specs.spinRate)
    };
  };

  useEffect(() => {
    var sum = 0;
    trackmanEvent.forEach((event) => {
      sum += event.data.Carry;
    });
    var sumInYards = sum * 1.0936;
    setAvgCarry(
      Number.parseFloat(sumInYards / trackmanEvent.length).toFixed(2)
    );
    
    // Calculate averages for the other metrics
    setAverages(calculateAverages());
  }, [trackmanEvent]);
  useEffect(() => {
    WebSocketConnection.setOnMessageCallback((data) =>
      setTrackmanEvent([...data])
    );
  }, []);
  return (
    <Grid container>
      <Grid item xs={12} display="flex">
        <Typography variant="h4" sx={{ width: "50%" }}>
          Capturing Trackman Information
        </Typography>
        <Typography variant="p" sx={{ width: "55%" }}>
          Swings records highlighted in red are missing a Trackman parameter;
          the Trackman failed to capture a data point used for recommendations.
          Recommend to delete this record as any remaining records highlighted
          in red will be ignored by the AI model. Remember, 10 swings
          recommended for initial gamer club; 4-6 swings for each subsequent
          equipment.
        </Typography>
        <Box
          display="flex"
          flexDirection="row-reverse"
          sx={{ width: "20%", height: "35%" }}
        >
          <Button
            variant="contained"
            onClick={onAnalyze}
            disabled={trackmanEvent.length > 0 ? false : true}
          >
            Analyze Data
          </Button>
        </Box>
      </Grid>
      <Grid item xs={12} display="flex" alignItems="center">
        {trackmanEvent.length === 0 ? (
          <Typography>Waiting to recieve Trackman data....</Typography>
        ) : null}
      </Grid>
      <Grid item xs={12}>
        <List>
          {trackmanEvent.length > 0 ? (
            <>
              <EventItemHeader
                totalSwings={trackmanEvent.length}
                averageSwing={avgCarry}
                averages={averages}
                onDelete={() => {
                  WebSocketConnection.clearGatheredData();
                  setTrackmanEvent([]);
                }}
              />
              <Divider />
            </>
          ) : null}
          {trackmanEvent.map((data, index) => {
            return (
              <EventItem
                key={data.key}
                event={data}
                onDelete={(key) => {
                  var newDataSet = trackmanEvent.filter(
                    (event) => event.key !== key
                  );
                  WebSocketConnection.data = newDataSet;
                  setTrackmanEvent([...newDataSet]);
                }}
                color={index % 2 ? "lightgray" : "white"}
              />
            );
          })}
        </List>
      </Grid>
    </Grid>
  );
};

export default SwingRecording;
